import { isMatchingMediaQuery } from "../utils/breakpoints";
import { videoResources } from "./videos/resources";

export class AssetsLoader {
  private static _videoBlobURLs = new Map<string, string>();

  private static async getVideoCache() {
    return window.caches.open("video-cache");
  }

  private static async fetchAndCache(src: string, cache: Cache) {
    const cachedResponse = await cache.match(src);

    const response = cachedResponse ?? (await fetch(src));

    if (!response.ok) {
      throw new Error(`Failed to load: ${src}`);
    }

    if (response !== cachedResponse) {
      await cache.put(src, response.clone());
    }

    return this._videoBlobURLs.get(src) ?? this.addBlobToMap(response, src);
  }

  private static async addBlobToMap(response: Response, key: string) {
    const blobURL = URL.createObjectURL(await response.blob());
    this._videoBlobURLs.set(key, blobURL);

    return blobURL;
  }

  static async loadAllVideoAssets() {
    const cache = await this.getVideoCache();
    const loaders = videoResources
      .filter(({ media }) => isMatchingMediaQuery(media))
      .flatMap(({ src, poster }) => [
        this.fetchAndCache(src, cache),
        this.fetchAndCache(poster, cache),
      ]);

    await Promise.all(loaders);
  }

  static async getBlobURL(src: string) {
    return (
      this._videoBlobURLs.get(src) ??
      this.fetchAndCache(src, await this.getVideoCache())
    );
  }
}
